import { palette } from "lib/miolo";
import IconCard, { CardDescription, CardValue } from "components/company/v2/cards/IconCard";
import { lightFormat } from "date-fns";
import type { IBrazilianCompanyIssuerTopLevelFragment } from "lib/fragments/__generated__/BrazilianCompanyIssuerTopLevel.generated";
import parseDateYmd from "lib/utils/parseDateYmd";
import numeral from "numeral";

interface IMarketCapCardProps {
  issuer: IBrazilianCompanyIssuerTopLevelFragment;
}

export default function MarketCapCard({ issuer }: IMarketCapCardProps) {
  const icon = (
    <svg xmlns="http://www.w3.org/2000/svg" width={14} height={14} viewBox="0 0 20 20">
      <g transform="translate(-28 -35)" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
        <g stroke="currentColor" strokeWidth={2} transform="translate(28 35)">
          <circle cx={10} cy={10} r={9.063} />
          <path d="M12.813 5.938H9.219a2.03 2.03 0 00-2.031 2.03h0A2.03 2.03 0 009.218 10h1.563c1.122 0 2.031.91 2.031 2.031h0a2.03 2.03 0 01-2.03 2.031H7.186M10 4.688v.625m0 9.375v.625" />
        </g>
      </g>
    </svg>
  );

  if (!issuer.marketCapitalization) {
    return null;
  }

  return (
    <div>
      <IconCard primaryColor={palette.mariner} secondaryColor={palette.selago} icon={icon}>
        <CardValue title={numeral(issuer.marketCapitalization.totalCapitalization).format("0,0")}>
          R${numeral(issuer.marketCapitalization.totalCapitalization).format("0.0a").replace(".0", "").toUpperCase()}
        </CardValue>
        <CardDescription>
          Market Cap • {lightFormat(parseDateYmd(issuer.marketCapitalization.asOfDate), "dd/MM/yyyy")}
        </CardDescription>
      </IconCard>
    </div>
  );
}
